import React from 'react';
import PropTypes from 'prop-types';

import { getSmartImage } from '../../helpers/helpers';

const ShopmyImage = ({ source, alt, ...props }) => {
  if (!source) return null;
  const imageUrl = typeof source === 'string' ? source : source.uri || source.url;
  if (!imageUrl) return null;
  return <img {...props} src={getSmartImage(imageUrl)} alt={alt} />;
};

ShopmyImage.propTypes = {
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  alt: PropTypes.string
};

ShopmyImage.defaultProps = {
  alt: ''
};

export default ShopmyImage;
